import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

export default function BlogView(props) {
  const history = useHistory();
  const params = props.match.params;
  const [loading, setLoading] = useState(true);
  const [blog, setBlog] = useState({});
  const [email, setEmail] = useState("");
  const [feedback, setfeedback] = useState("");

  const Feedback = async (email, feedback) => {
    if (email !== "") {
      const { status, data } = await axios.post(
        "https://webstarkmail.herokuapp.com/api/email/send",
        {
          email: "irfanukani2@gmail.com",
          subject: "Feedback | IrfanWrites",
          data: `Respected Sir , <br> <br> ${email} sent you a feedback on the blog ${blog.title} ! <br ><br> ${feedback}`,
          userlink: `https://irfanwrites.web.app`,
          ref: "Irfan Writes App",
          api_key: "8qbr96cw",
        }
      );
    }
  };

  useEffect(() => {
    async function FetchBlog() {
      const { status, data } = await axios.get(
        `https://irfanwrites.herokuapp.com/posts/${params.id}`
      );
      if (status === 200) {
        setLoading(false);
        console.log(data);
        setBlog(data);
      }
    }

    FetchBlog();
  }, [params.id]);

  if (!loading) {
    return (
      <>
        <div
          class='modal fade'
          id='exampleModal'
          tabindex='-1'
          aria-labelledby='exampleModalLabel'
          aria-hidden='true'
        >
          <div class='modal-dialog'>
            <div class='modal-content'>
              <div class='modal-header'>
                <h5 class='modal-title' id='exampleModalLabel'>
                  feedback
                </h5>
                <button
                  type='button'
                  class='btn-close'
                  data-mdb-dismiss='modal'
                  aria-label='Close'
                ></button>
              </div>
              <div class='modal-body d-flex flex-column'>
                <div>
                  <label>Email :</label>
                  <input
                    type='text'
                    class='form-control'
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <br />
                <div>
                  <label>Feedback :</label>
                  <textarea
                    class='form-control'
                    value={feedback}
                    onChange={(e) => {
                      setfeedback(e.target.value);
                    }}
                  />
                </div>
                <br />
                <br />
                Thanks for Reading!!
              </div>
              <div class='modal-footer'>
                <button
                  type='button'
                  class='btn btn-danger'
                  data-mdb-dismiss='modal'
                  onClick={() => {
                    Feedback(email, feedback);
                    alert("Feedback Sent");
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='container-lg mt-5 pt-3'>
          <button
            class='btn btn-floating '
            onClick={() => {
              history.push("/");
            }}
          >
            <i class='fas fa-angle-left'></i>
          </button>
          <div class='container-lg mt-5'>
            <div class='row '>
              <div class='col-sm-12  col-md-12 col-xl-12'>
                <div class='container-fluid'>
                  <h1 className={"text-dark"}>{blog.title}</h1>
                  <p class='text-black-50 fs-5'>
                    {blog.addedAt !== undefined
                      ? blog.addedAt.slice(0, 10)
                      : ""}{" "}
                    | By Irfan Ukani
                  </p>
                  <div class='text-dark mt-5'>
                    <div dangerouslySetInnerHTML={{ __html: blog.body }}></div>
                  </div>
                  <div class='btns mt-5 pt-5'>
                    <button
                      class='btn btn-link'
                      data-mdb-toggle='modal'
                      data-mdb-target='#exampleModal'
                    >
                      Provide a feedback
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    //   Spinner
    return (
      <div class='d-flex mt-5 pt-5 justify-content-center'>
        <div class='spinner-grow' role='status'>
          <span class='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }
}
